import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManufacturerClient, ManufacturerDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-manufacturer-control',
  templateUrl: './manufacturer-control.component.html',
  styleUrls: ['./manufacturer-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ManufacturerControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ManufacturerControlComponent),
      multi: true,
    }
  ]
})
export class ManufacturerControlComponent extends BaseAutocompleteControl<ManufacturerDto> implements OnInit {

  constructor(
    private manufacturerClient: ManufacturerClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<ManufacturerDto[]> {
    const cacheKey = `manufacturer_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.manufacturerClient.getManufacturerByKeySearch(searchValue).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: ManufacturerDto | null): string {
    return item?.name || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof ManufacturerDto;
  }
}
